import React, { Component, Fragment } from "react";
import NavLink from "./NavLink";
import SearchMobile from "./SearchMobile";
import "./NavigationMobile.css";
import OnlineRetentionTouchPoint from "../Navigation/OnlineRetentionTouchPoint";
import OtpInput from "../OtpInput";

class NavigationMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      showLoginBlock: false,
      activeMenuId: 0,
      searchActive: false,
      searchResultStates: {
        searchResultsData: { searchResults: [] },
        searchNotFound: false,
      },
    };
    this.updateInputMSISDN = this.props.updateInputMSISDN;
    this.updateInputPW = this.props.updateInputPW;
    this.navDoLogin = this.props.navDoLogin;
    this.navDoLogout = this.props.navDoLogout;
    this.navShowLoginDialog = this.props.navShowLoginDialog;
    this.navHideLoginDialog = this.props.navHideLoginDialog;
    this.goToDtPlatform = this.props.goToDtPlatform;
    this.updateLoginMode = this.props.updateLoginMode;
    this.currentSelectedTab = this.props.currentSelectedTab;
    this.handleCheckLoginId = this.props.handleCheckLoginId;
    this.handleSendLoginIdOTP = this.props.handleSendLoginIdOTP;
    this.updateLoginStep=this.props.updateLoginStep;
    this.whenPressEnter = this.props.whenPressEnter;
    this.setOtp = this.props.setOtp;
  }

  getNavBarBodyHTML() {
    let activeMenuId = this.state.activeMenuId;
    let lang = window.THREE_REACT_APP_GLOBAL.language || "en";

    let html = this.props.topNavMenu.items.map((menu, index) => (
      <div
        key={index}
        className={"nav-list-body" + (activeMenuId == menu.id ? " active" : "")}
      >
        <h2 onClick={() => this.showMenuItem(menu)}>{menu.title}</h2>
        <ul className="nav-category-list nav-list">


          {
            menu.id === "2"? (
              menu.items.map((item, index) => {

                const subHeaderNewCustomer = lang === "en" ? "For New Customers"  : "新客戶";
                const subHeaderExistingCustomer = lang === "en" ? "For Existing Customers"  : "現有客戶";
                const {id,href,isNewWindow,label} = item;

                if(id === "1" || id === "11"){
                  return (
                      <Fragment>
                          <div className='sub-header-label'>{id === "1" ? subHeaderNewCustomer : subHeaderExistingCustomer}</div>
                          <li key={id}>
                            <a
                              href={href}
                              target={isNewWindow === true ? "_blank": "_self"}
                            >
                              {label}
                            </a>
                          </li>
                      </Fragment>
                  )
              }

                return (
                  <li key={index}>
                    <a
                      href={href}
                      target={isNewWindow? "_blank": "_self"}
                      style={{marginLeft: id > 100 ?"15px" : 0}}
                    >
                      {label}
                    </a>
                  </li>
                )
              })
            ):(
              menu.items.map((item, index) => {

                const {id,href,isNewWindow,label} = item;

                return (
                  <li key={index}>
                    <a
                      href={href}
                      target={isNewWindow? "_blank": "_self"}
                      style={{marginLeft: id > 100 ?"15px" : 0}}
                    >
                      {label}
                    </a>
                  </li>
                )
              })
            )
          }
        </ul>
      </div>
    ));

    return html;
  }

  showMenuItem = (menu) => {
    let activeMenuId = this.state.activeMenuId;
    this.navHideLoginDialog();
    this.setState({ activeMenuId: activeMenuId == menu.id ? "" : menu.id });
  };

  renderMentionPoints = (mentionPoints) =>
    mentionPoints.map((point) => <li>{point.desc}</li>);

  getLoginBlock() {
    const { login, loginProfile } = this.props;
    const { inputMSISDN, loginDialogDisplay,errorDetail, loginRemark, otp, loginStep,isResendOTPButtonShown } = loginProfile;

    const loginBlock = login.block;
    const lang = window.THREE_REACT_APP_GLOBAL.language || "en";
    const langBAUPlatform = lang === "en" ? "eng" : "chi";

    const platformBAUForgetPasswordURL = `${process.env.REACT_APP_THREE_COM_DOMAIN}/3Care/inquiryUserInfo.do?appId=setpassword&lang=${langBAUPlatform}`;
    const platformDTForgetEmailURL = `${
      process.env.REACT_APP_DT_POSTPAID_BASE_URL
    }/${lang}/account/purchase?popup=forget_email`;
    const platformDTNewRegisterURL = `${
      process.env.REACT_APP_DT_POSTPAID_BASE_URL
    }/${lang}/account/purchase?popup=new_register`;

    const labelButtonForgetEmail = lang === "en" ? "Forgot Login Email?" : "忘記登入電郵?";
    const labelButtonNewRegister = lang === "en" ? "Register Account" : "新客戶註冊";
    const labelNot3Customers = lang === "en" ? "Not 3 existing customers? " : "不是3現有客戶?";
    const labelButtonNext = lang === "en" ? "Next" : "下一步";
    const labelButtonForgetPassword = lang === "en" ? "Forgot Password?" : "忘記密碼?";
    const labelPassword = lang === "en" ? "Password" : "密碼";
    const labelChange = lang === "en" ? "Change" : "更改";
    const labelLogin = lang === "en" ? "Login" : "登入";
    //const labelPasswordError = lang === "en" ? "Invalid password, please re-enter" :"輸入之密碼不正確，請重新輸入!";
    const labelReconnectRemark = lang === "en" ? 
    `Please <a href="${process.env.REACT_APP_THREE_COM_DOMAIN}/3Care/?lang=${langBAUPlatform}">click here</a> to reconnect the service if your mobile account has been suspended.` :
    `如閣下之流動電話戶口已暫停服務，請<a href="${process.env.REACT_APP_THREE_COM_DOMAIN}/3Care/?lang=${langBAUPlatform}">登入</a>「我的賬戶」辦理重開服務​。`;
    const labelChangePasswordRemark = lang === "en" ? "Friendly reminder: Change password regularly to prevent hacking attempts." :"溫馨提示：定期更改登入密碼，防止黑客入侵。";


    const labelLoginId = inputMSISDN.trim().replace(/\d{4}(?=.)/g, "$& ");
    const labelInputOTP = lang === "en" ? `Please enter One-Time Password (OTP)`:`請輸入一次性驗證碼 (OTP)`;
    const labelResendHTML = lang === "en" ? `Please <span><u>click here</u></span> to re-send`:`請<span><u>按此</u></span>重發`;
    const labelInputOTPRemark = lang === "en" ? "One-Time Password (OTP) has been sent to your registered mobile number." :"一次性密碼已發送到你登記的流動電話號碼";
    const labelVerify = lang === "en" ? 'Verify': "驗證";


    switch(loginStep){
      case 'ENTER_LOGIN_ID':
        return (
          <div
            className={
              "login-block" + (loginDialogDisplay ? " show-login" : " hide-login")
            }
          >
            <svg height="20" width="40">
              <path d="M20 0 L0 20 L40 20 Z" />
            </svg>
            <div className={"text login-main-block flex mobileBlock"}>
              <div className="close">
                <button
                  type="button"
                  className="btn-image navbar-menu navbar-close"
                  onClick={() => this.navHideLoginDialog()}
                >
                  <img
                    src="/assets/images/nav/close.png"
                    className="navbar-icon"
                    alt="Close"
                  />
                </button>
              </div>
  
              <div className="title">{loginBlock.title}</div>
              <div className="desc">{loginBlock.desc}</div>
  
              {this.props.renderCommonInputFields()}

              <div
                  className="error"
                  style={{ display: errorDetail != null &&errorDetail.length > 0 ? "block" : "none" }}
                >
                      <div dangerouslySetInnerHTML={{__html:errorDetail}}/>
              </div>
  
              <div className="label-no-3customer">
                {labelNot3Customers}{" "}
                <a className="new-register" href={platformDTNewRegisterURL}>
                  {labelButtonNewRegister}
                </a>
              </div>
  
              <a className="forget-email" href={platformDTForgetEmailURL}>
                {labelButtonForgetEmail}
              </a>


              <div className="label-reconnect-remark"> 
                  <div dangerouslySetInnerHTML={{__html:labelReconnectRemark}}/>
              </div>  

              <div className="container-login-button">
                <p className="label-change-password-remark">{labelChangePasswordRemark}</p>
  
                <button
                  className={"login-btn"}
                  type="submit"
                  onClick={() => this.handleCheckLoginId()}
                >
                  {labelButtonNext}
                </button>
              </div>
            </div>
          </div>
        );
      case 'ENTER_LOGIN_PASSWORD':
        return (
          <div
            className={
              "login-block" + (loginDialogDisplay ? " show-login" : " hide-login")
            }
          >
            <svg height="20" width="40">
              <path d="M20 0 L0 20 L40 20 Z" />
            </svg>
            <div className={"text login-main-block flex mobileBlock"}>
              <div className="close">
                <button
                  type="button"
                  className="btn-image navbar-menu navbar-close"
                  onClick={() => this.navHideLoginDialog()}
                >
                  <img
                    src="/assets/images/nav/close.png"
                    className="navbar-icon"
                    alt="Close"
                  />
                </button>
              </div>
              <div className="title">
                {labelLogin} {labelLoginId} 
                <button
                  class="btn-link"
                  onClick={() => this.updateLoginStep('ENTER_LOGIN_ID')}
                  >
                  {labelChange}
                </button>
              </div>
  
              <div className="label-user-id">{labelPassword}</div>
              <input
                type="password"
                onChange={(e) => this.updateInputPW(e)}
                onKeyDown={(e) => this.whenPressEnter(e)}
              />
              <div
                  className="error"
                  style={{ display: errorDetail != null && errorDetail.length > 0 ? "block" : "none" }}
              >
                  <div dangerouslySetInnerHTML={{__html:errorDetail}}/>
  
              </div>
  
  
              <a className="link" href={platformBAUForgetPasswordURL}>
                {labelButtonForgetPassword}
              </a>
  
              <div className="container-login-button">
  
                <p className="label-change-password-remark">{labelChangePasswordRemark}</p>
  
                <button
                  className={"login-btn"}
                  type="submit"
                  onClick={() => this.handleSendLoginIdOTP()}
                >
                  {loginBlock.loginBtnLabel}
                </button>
              </div>
            </div>
          </div>
        );
      case 'ENTER_LOGIN_OTP':
        return (
          <div
            className={
              "login-block" + (loginDialogDisplay ? " show-login" : " hide-login")
            }
          >
            <svg height="20" width="40">
              <path d="M20 0 L0 20 L40 20 Z" />
            </svg>
            <div className={"text login-main-block flex mobileBlock"}>
              <div className="close">
                <button
                  type="button"
                  className="btn-image navbar-menu navbar-close"
                  onClick={() => this.navHideLoginDialog()}
                >
                  <img
                    src="/assets/images/nav/close.png"
                    className="navbar-icon"
                    alt="Close"
                  />
                </button>
              </div>
              <div className="title">
                {labelLogin} {labelLoginId} 
                <button
                  class="btn-link"
                  onClick={() => this.updateLoginStep('ENTER_LOGIN_ID')}
                >
                  {labelChange}
                </button>
              </div>

              <div
                  className="label-input-otp-remark"
                  style={{ display: loginRemark != null && loginRemark.length > 0 ? "block" : "none" }}
                >
                      <div dangerouslySetInnerHTML={{__html:loginRemark}}/>
              </div>

              <div className="label-user-id">{labelInputOTP}</div>
  
              <OtpInput
                  style={{paddingTop:10,paddingBottom:10}}
                  value={otp}
                  numInputs={6}
                  onChange={this.setOtp}
                  onEnterPress={this.navDoLogin}
              />
  
              {/* {
                isResendOTPButtonShown &&
                <button 
                  className="btn-resend-otp" 
                  type="button" 
                  onClick={() => this.handleSendLoginIdOTP()}
                  dangerouslySetInnerHTML={{__html:labelResendHTML}}
                />
              } */}

              <div
                  className="error"
                  style={{ display: errorDetail != null &&errorDetail.length > 0 ? "block" : "none" }}
                >
                    <div dangerouslySetInnerHTML={{__html:errorDetail}}/>
              </div>


              <div className="container-login-button">
  
                <button
                  className={"login-btn"}
                  type="submit"
                  onClick={() => this.navDoLogin()}
                >
                  {labelVerify}
                </button>
              </div>
            </div>
          </div>
        );
    }
  }

  mobileOpenLoginDialog = () => {
    this.navShowLoginDialog();
    this.setState({
      activeMenuId: 0,
      active: "",
    });
  };

  setSearchResultStates = (data, isFound) => {

    this.setState({
      searchResultStates: {
        searchResultsData: data,
        searchNotFound: isFound,
      },
    });
  };

  getLoginHTML() {
    let loginProfile = this.props.loginProfile;

    if (loginProfile.isLogin) {
      return <React.Fragment />;
    } else {
      return (
        <React.Fragment>
          {/*<a href={"#"} onClick={() => this.mobileOpenLoginDialog()}>*/}
          {/*    <span className="v-align-middle"></span>*/}
          {/*    <img src={Icon_User} className="navbar-icon" alt=""/>*/}
          {/*    <span className="navbar-label">{this.props.login.loginLabel}</span>*/}
          {/*</a>*/}
          {this.getLoginBlock()}
        </React.Fragment>
      );
    }
  }

  getSearchHTML() {
    let searchActive = this.state.searchActive;
    return [
      <div
        className={"search-input-block"}
        onClick={(e) => {
          searchActive || this.setState({ searchActive: true });
        }}
      >
        <div className={"search-text"}>
          <input id="mobile-search-input" type={"text"} />
        </div>
        <div className={"search-btns-block"}>
          <button
            onClick={(e) => {
              this.searchMobile.handleSearchSubmit(e);
            }}
            className={"search-btn"}
          >
            <img src="/assets/images/icon_search.svg" className="navbar-icon" alt="Search" />
          </button>
          <button
            onClick={(e) => {
              document.getElementById("mobile-search-input").value = "";
              this.setState({
                searchActive: false,
                searchResultsData: { searchResults: [] },
                searchNotFound: false,
              });

            }}
            className={"search-cancel-btn"}
          >
            Cancel
          </button>
        </div>
      </div>,
      <SearchMobile
        ref={(instance) => {
          this.searchMobile = instance;
        }}
      />,
    ];
  }

  renderLogoutBtn = (loginProfile) => {
    let loginStatus = loginProfile.isLogin;

    if (loginStatus === true) {
      if (loginProfile.isDtAccount === true) {
        return <React.Fragment />;
      } else {
        return (
          <React.Fragment>
            <div
              className={"nav-list-body nav-list-body-logout"}
              onClick={() => this.navDoLogout()}
            >
              <h2>{this.props.login.logoutLabel}</h2>
            </div>
          </React.Fragment>
        );
      }
    } else {
      return <React.Fragment />;
    }
  };

  getAfterLoginMenu = (loginProfile) => {
    let lang = window.THREE_REACT_APP_GLOBAL.language || "en";
    let imgWrapperClass = lang === "en" ? " imgWrapperEN" : " imgWrapperTC";

    let theme = this.props.theme;
    let bgStyle = {};
    if (theme.control === "ON") {
      bgStyle = {
        background: "url('" + theme.mobileMenuImg + "') no-repeat",
        //backgroundSize: "100% 100%",
        backgroundSize: "100% auto",
        backgroundColor: "#ebebed",
      };
    }

    if (loginProfile.isLogin === true) {
      if (loginProfile.isDtAccount === true) {
        let userImg = "/assets/images/icon_user.svg";

        if (loginProfile.dtProfilePic !== "") {
          userImg = loginProfile.dtProfilePic;
        }

        let displayName = loginProfile.msisdn;

        if (displayName.length === 8) {
          displayName =
            loginProfile.msisdn.substring(0, 4) +
            " " +
            loginProfile.msisdn.substring(4, 8);
        }

        return (
          <React.Fragment>
            <div
              className={
                "nav-list-body nav-list-body-dt nav-list-loginbar nav-list-afterlogin" +
                (this.state.activeMenuId === 99 ? " active" : "")
              }
              style={bgStyle}
            >
              <h2
                onClick={() => {
                  this.showAfterLoginMenuItem();
                  this.goToDtPlatform();
                }}
              >
                <span className="v-align-middle" />
                <div className={"imgWrapper" + imgWrapperClass}>
                  <img
                    src={userImg}
                    className="navbar-icon"
                    alt=""
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "15px",
                    }}
                  />
                </div>
                <div className={"labelWrapper"}>{displayName}</div>
              </h2>
            </div>
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment>
            <div
              className={
                "nav-list-body nav-list-loginbar nav-list-afterlogin" +
                (this.state.activeMenuId === 99 ? " active" : "")
              }
              style={bgStyle}
            >
              <h2 onClick={() => this.showAfterLoginMenuItem()}>
                <span className="v-align-middle" />
                <div className={"imgWrapper" + imgWrapperClass}>
                  <img src="/assets/images/icon_user.svg" className="navbar-icon" alt="" />
                </div>
                <div className={"labelWrapper"}>
                  {loginProfile.msisdn.substring(0, 4) +
                    " " +
                    loginProfile.msisdn.substring(4, 8)}
                </div>
              </h2>
              <ul className={"nav-category-list nav-list"}>
                {this.props.login.block.logoutMenu.map((item, index) => (
                  <li
                    key={index}
                    onClick={(e) => (window.location.href = item.href)}
                  >
                    <a>{item.desc}</a>
                  </li>
                ))}

                <OnlineRetentionTouchPoint loginProfile={loginProfile} />

                <li
                  className={"nav-list-body nav-list-body-logout"}
                  onClick={() => this.navDoLogout()}
                >
                  <a>{this.props.login.logoutLabel}</a>
                </li>
              </ul>
            </div>
          </React.Fragment>
        );
      }
    } else {
      return (
        <React.Fragment>
          <div
            className={
              "nav-list-body nav-list-loginbar nav-list-beforelogin" +
              (this.state.activeMenuId === 99 ? " active" : "")
            }
            style={bgStyle}
          >
            <h2 onClick={() => this.mobileOpenLoginDialog()}>
              <span className="v-align-middle" />
              <div className={"imgWrapper" + imgWrapperClass}>
                <img src="/assets/images/icon_user.svg" className="navbar-icon" alt="" />
              </div>
              <div className={"labelWrapper"}>
                {this.props.login.loginLabel}
              </div>
              {/*{this.getLoginBlock()}*/}
            </h2>
          </div>
        </React.Fragment>
      );
    }
  };

  showAfterLoginMenuItem = () => {
    let activeMenuId = this.state.activeMenuId;
    let afterLoginMenuID = 99;
    this.navHideLoginDialog();
    this.setState({
      activeMenuId: activeMenuId === afterLoginMenuID ? "" : afterLoginMenuID,
    });
  };

  showSearchMobile = () => {
    return (
      <SearchMobile
        setSearchResultStates={(data, isFound) =>
          this.setSearchResultStates(data, isFound)
        }
        searchResultStates={this.state.searchResultStates}
        ref={(instance) => {
          this.searchMobile = instance;
        }}
      />
    );
  };

  render() {
    let searchActive = this.state.searchActive;
    let footer = this.props.footer;

    let loginProfile = this.props.loginProfile;

    let lang = window.THREE_REACT_APP_GLOBAL.language || "en";
    let closeWrapperClass =
      lang === "en" ? " closeWrapperEN" : " closeWrapperTC";

    return (
      <div id="navbar-xs">
        <nav
          className={
            "navbar-top" + (searchActive === true ? " navbar-top-active" : "")
          }
        >
          <div
            className={
              "navbar-top-left" +
              (searchActive === true ? " navbar-top-left-expanded" : "")
            }
          >
            {this.getLoginHTML()}
            <div className={"mobile-search" + (searchActive ? " active" : "")}>
              {/*{this.getSearchHTML()}*/}
              <div
                className={"search-input-block"}
                onClick={(e) => {
                  searchActive || this.setState({ searchActive: true });
                }}
              >
                <div className={"search-text"}>
                  <input
                    placeholder={this.props.searchLabel.inputPlaceholder}
                    id="mobile-search-input"
                    type={"text"}
                  />
                </div>
                <div className={"search-btns-block"}>
                  <button
                    onClick={(e) => {
                      this.searchMobile.handleSearchSubmit(e);
                    }}
                    className={"search-btn"}
                  >
                    <img
                      src="/assets/images/icon_search.svg"
                      className="navbar-icon"
                      alt="Search"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="navbar-top-right">
            <span className="v-align-middle" />
            {searchActive ? (
              <button
                type="button"
                className={
                  "btn-image navbar-menu navbar-close" + closeWrapperClass
                }
                onClick={(e) => {
                  document.getElementById("mobile-search-input").value = "";
                  this.setState({
                    searchActive: false,
                    searchResultStates: {
                      searchResultsData: { searchResults: [] },
                      searchNotFound: false,
                    },
                  });
                }}
              >
                <img
                  src="/assets/images/nav/close.png"
                  className="navbar-icon"
                  alt="Close"
                />
              </button>
            ) : (
              <button
                type="button"
                className={
                  "btn-image navbar-menu navbar-close" + closeWrapperClass
                }
                onClick={(e) => {
                  // close mobile menu
                  document
                    .querySelector("#navbar-xs")
                    .classList.toggle("is-expanded");
                  document
                    .querySelector("body")
                    .classList.toggle("overflow-hidden");
                  document.getElementById("mobile-search-input").value = "";
                  this.setSearchResultStates({ searchResults: [] }, false);
                }}
              >
                <img
                  src="/assets/images/nav/close.png"
                  className="navbar-icon"
                  alt="Close"
                />
              </button>
            )}
          </div>
        </nav>

        <div style={{ display: searchActive ? "inline-flex" : "none" }}>
          {this.showSearchMobile()}
        </div>

        {/*<!-- navbar top END -->*/}

        <div
          className={"navbar-body" + (searchActive ? " hide" : "")}
          style={{ paddingBottom: 34 }}
        >
          {this.getAfterLoginMenu(loginProfile)}
          {this.getNavBarBodyHTML()}
          {/* this.renderLogoutBtn(loginProfile) */}
          <NavLink
            isMobile={true}
            topLink={this.props.topLink}
            langs={this.props.langs}
          />
        </div>
      </div>
    );
  }
}

export default NavigationMobile;
